import React, { useContext, useState } from 'react';
import '../styles/CreatePosts.css';
import { RxCross2 } from 'react-icons/rx';
import { GeneralContext } from '../context/GeneralContextProvider';
import axios from "axios";

const CreatePost = () => {

    const { isCreatPostOpen, setIsCreatePostOpen } = useContext(GeneralContext);

    const [postType, setPostType] = useState('photo');
    const [postDescription, setPostDescription] = useState('');
    const [postLocation, setPostLocation] = useState('');
    const [postFile, setPostFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState();

    const handlePostUplload = async (e) => {

        e.preventDefault();

        if (!postFile) {
            alert("Please select a photo or video");
            return;
        }

        try {

            setUploadProgress(1);

            // Create form data for Cloudinary
            const formData = new FormData();

            formData.append("file", postFile);
            formData.append("upload_preset", "socialex_upload");

            // Upload image or video depending on selected post type
            const resourceType =
                postType === "video" ? "video" : "image";

            const response = await axios.post(
                `https://api.cloudinary.com/v1_1/ktdod8i6/${resourceType}/upload`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {

                        if (progressEvent.total) {
                            const progress = Math.round(
                                (progressEvent.loaded * 100) /
                                progressEvent.total
                            );

                            setUploadProgress(progress);
                        }
                    }
                }
            );

            // Cloudinary returns the uploaded file URL
            const downloadURL = response.data.secure_url;

            console.log("File uploaded to Cloudinary:", downloadURL);

            // Keep your existing backend request structure
            const inputs = {
                userId: localStorage.getItem('userId'),
                userName: localStorage.getItem('username'),
                userPic: localStorage.getItem('profilePic'),
                fileType: postType,
                file: downloadURL,
                description: postDescription,
                location: postLocation,
                comments: {
                    "New user": "This is my forst comment"
                }
            };

            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}/createPost`,
                inputs
            );

            console.log("Post created:", res.data);
            window.dispatchEvent(new Event('postCreated'));

            // Reset form after successful upload
            setPostDescription('');
            setPostLocation('');
            setPostFile(null);
            setUploadProgress(undefined);
            setIsCreatePostOpen(false);

        } catch (error) {

            console.error(
                "Upload failed:",
                error.response?.data || error.message
            );

            alert("Upload failed. Please try again.");

            setUploadProgress(undefined);
        }
    };

    return (
        <>
            <div
                className="createPostModalBg"
                style={
                    isCreatPostOpen
                        ? { display: 'contents' }
                        : { display: 'none' }
                }
            >

                <div className="createPostContainer">

                    <RxCross2
                        className='closeCreatePost'
                        onClick={() => setIsCreatePostOpen(false)}
                    />

                    <h2 className="createPostTitle">
                        Create post
                    </h2>

                    <hr className="createPostHr" />

                    <div className="createPostBody">

                        <form>

                            <select
                                className="form-select"
                                aria-label="Select Post Type"
                                value={postType}
                                onChange={(e) =>
                                    setPostType(e.target.value)
                                }
                            >
                                <option value="photo">
                                    Photo
                                </option>

                                <option value="video">
                                    Video
                                </option>
                            </select>

                            <div className="uploadBox">

                                <input
                                    type="file"
                                    name="PostFile"
                                    id="uploadPostFile"
                                    accept={
                                        postType === "video"
                                            ? "video/*"
                                            : "image/*"
                                    }
                                    onChange={(e) =>
                                        setPostFile(e.target.files[0])
                                    }
                                />

                            </div>

                            <div className="form-floating mb-3 authFormInputs descriptionInput">

                                <input
                                    type="text"
                                    className="form-control descriptionInput"
                                    id="floatingDescription"
                                    placeholder="Description"
                                    onChange={(e) =>
                                        setPostDescription(e.target.value)
                                    }
                                    value={postDescription}
                                />

                                <label htmlFor="floatingDescription">
                                    Description
                                </label>

                            </div>

                            <div className="form-floating mb-3 authFormInputs postLocation">

                                <input
                                    type="text"
                                    className="form-control postLocation"
                                    id="floatingLocation"
                                    placeholder="Location"
                                    onChange={(e) =>
                                        setPostLocation(e.target.value)
                                    }
                                    value={postLocation}
                                />

                                <label htmlFor="floatingLocation">
                                    Location
                                </label>

                            </div>

                            {uploadProgress !== undefined ?

                                <button disabled>
                                    Uploading...
                                    {' '}
                                    {Math.round(uploadProgress)}%
                                </button>

                                :

                                <button
                                    onClick={handlePostUplload}
                                >
                                    Upload
                                </button>
                            }

                        </form>

                    </div>

                </div>

            </div>
        </>
    );
};

export default CreatePost;
